import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { LegalEntity, type LegalEntityConstructor } from './LegalEntity'

export const LegalEntityConstructorFactory =
  Factory.Sync.makeFactory<LegalEntityConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    name: Factory.each(() => faker.company.companyName()),
    baseCurrencyId: Factory.each(() => faker.random.number()),
    baseCurrencyName: Factory.each(() => faker.finance.currencyCode()),
    country: Factory.each(() => faker.address.country()),
    externalId: Factory.each(() => faker.random.alphaNumeric(6)),
    active: true,
    createdAt: Factory.each(() => faker.date.recent()),
    updatedAt: Factory.each(() => faker.date.recent()),
    locationCount: Factory.each(() => faker.random.number()),
  })

export const LegalEntityFactory = EntityFactory(
  LegalEntity,
  LegalEntityConstructorFactory
)
